import { MetadataStore } from 'breeze-client';

import { Account } from './account';
import { AccountCryptonym } from './account-cryptonym';
import { AccountImage } from './account-image';
import { ActiveStatus } from './active-status';
import { Addon } from './addon';
import { AddonBin } from './addon-bin';
import { AddonBinStationStatus } from './addon-bin-station-status';
import { AddonBinStatus } from './addon-bin-status';
import { AddonDoc } from './addon-doc';
import { AddonDocMap } from './addon-doc-map';
import { AddonImage } from './addon-image';
import { AddonStation } from './addon-station';
import { AuthNetSubmission } from './auth-net-submission';
import { BarcodePrintStatus } from './barcode-print-status';
import { BoxSize } from './box-size';
import { CancellationReasonType } from './cancellation-reason-type';
import { CancellationRequest } from './cancellation-request';
import { CancellationRequestDetail } from './cancellation-request-detail';
import { CancellationRequestDetailStatus } from './cancellation-request-detail-status';
import { CancellationRequestStatus } from './cancellation-request-status';
import { CatalogFeed } from './catalog-feed';
import { Config } from './config';
import { CreditMemo } from './credit-memo';
import { CreditMemoLedgerEntry } from './credit-memo-ledger-entry';
import { CreditMemoLedgerEntryKind } from './credit-memo-ledger-entry-kind';
import { CreditMemoStatus } from './credit-memo-status';
import { CreditMemoType } from './credit-memo-type';
import { DocSubmitType } from './doc-submit-type';
import { EOQType } from './eoq-type';
import { Email } from './email';
import { EntityEvent } from './entity-event';
import { EntityEventType } from './entity-event-type';
import { EntityIssue } from './entity-issue';
import { Feature } from './feature';
import { FeatureChoice } from './feature-choice';
import { FeatureKind } from './feature-kind';
import { GLAccount } from './gl-account';
import { GLSubmission } from './gl-submission';
import { GenId } from './gen-id';
import { Image } from './image';
import { InvoiceDetail } from './invoice-detail';
import { InvoiceHeader } from './invoice-header';
import { InvoiceStatus } from './invoice-status';
import { ItemBin } from './item-bin';
import { ItemDetail } from './item-detail';
import { ItemDetailAddon } from './item-detail-addon';
import { ItemDetailHist } from './item-detail-hist';
import { ItemDetailLog } from './item-detail-log';
import { ItemDetailStatus } from './item-detail-status';
import { ItemReplacement } from './item-replacement';
import { ItemReplacementStatus } from './item-replacement-status';
import { ItemReplacementType } from './item-replacement-type';
import { JoDetail } from './jo-detail';
import { JoDetailAddon } from './jo-detail-addon';
import { JoExpectedShipDateHistory } from './jo-expected-ship-date-history';
import { JoHeader } from './jo-header';
import { JoHeaderPull } from './jo-header-pull';
import { JoNote } from './jo-note';
import { JoNoteType } from './jo-note-type';
import { JoPullBatch } from './jo-pull-batch';
import { JoStatus } from './jo-status';
import { Manifest } from './manifest';
import { ManifestGroup } from './manifest-group';
import { ManifestGroupInvoice } from './manifest-group-invoice';
import { Manufacturer } from './manufacturer';
import { ManufacturerCryptonym } from './manufacturer-cryptonym';
import { ManufacturerFeatureKindMap } from './manufacturer-feature-kind-map';
import { ManufacturerFeedStatus } from './manufacturer-feed-status';
import { ManufacturerImage } from './manufacturer-image';
import { ManufacturerProductTypeConfig } from './manufacturer-product-type-config';
import { ManufacturerProductTypeConfigAddon } from './manufacturer-product-type-config-addon';
import { NotificationEvent } from './notification-event';
import { NotificationQuery } from './notification-query';
import { NotificationSendLog } from './notification-send-log';
import { NotificationTemplate } from './notification-template';
import { NotificationType } from './notification-type';
import { PoCancelRequestQueue } from './po-cancel-request-queue';
import { PoDetail } from './po-detail';
import { PoDetailCancel } from './po-detail-cancel';
import { PoDetailType } from './po-detail-type';
import { PoHeader } from './po-header';
import { PoNote } from './po-note';
import { PoNoteType } from './po-note-type';
import { PoStatus } from './po-status';
import { PoTrx } from './po-trx';
import { PoTrxHist } from './po-trx-hist';
import { Product } from './product';
import { ProductEOQ } from './product-eoq';
import { ProductFeatureChoice } from './product-feature-choice';
import { ProductReplacement } from './product-replacement';
import { ProductType } from './product-type';
import { ProductTypeAlt } from './product-type-alt';
import { ProductTypeFeatureMap } from './product-type-feature-map';
import { ProductTypeImage } from './product-type-image';
import { ProductTypeTag } from './product-type-tag';
import { ProductTypeTagMap } from './product-type-tag-map';
import { ProxReceipt } from './prox-receipt';
import { ProxReceiptStatus } from './prox-receipt-status';
import { ProxSubmission } from './prox-submission';
import { ProxSubmissionStatus } from './prox-submission-status';
import { QBAccount } from './qb-account';
import { QBItem } from './qb-item';
import { ReturnReasonType } from './return-reason-type';
import { ReturnRequest } from './return-request';
import { ReturnRequestDetail } from './return-request-detail';
import { ReturnRequestDetailStatus } from './return-request-detail-status';
import { ReturnRequestStatus } from './return-request-status';
import { ShipBin } from './ship-bin';
import { ShipFrequency } from './ship-frequency';
import { Shipment } from './shipment';
import { ShipmentStatus } from './shipment-status';
import { ShippingBox } from './shipping-box';
import { StagedFeedRun } from './staged-feed-run';
import { StagedProductColor } from './staged-product-color';
import { StagedProductPart } from './staged-product-part';
import { StagedProductType } from './staged-product-type';
import { SystemImage } from './system-image';
import { TestParameter } from './test-parameter';
import { UnwindEvent } from './unwind-event';
import { UserPref } from './user-pref';
import { Warehouse } from './warehouse';
import { WarningType } from './warning-type';

export class UniformaxRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Account', Account);
        metadataStore.registerEntityTypeCtor('AccountCryptonym', AccountCryptonym);
        metadataStore.registerEntityTypeCtor('AccountImage', AccountImage);
        metadataStore.registerEntityTypeCtor('ActiveStatus', ActiveStatus);
        metadataStore.registerEntityTypeCtor('Addon', Addon);
        metadataStore.registerEntityTypeCtor('AddonBin', AddonBin);
        metadataStore.registerEntityTypeCtor('AddonBinStationStatus', AddonBinStationStatus);
        metadataStore.registerEntityTypeCtor('AddonBinStatus', AddonBinStatus);
        metadataStore.registerEntityTypeCtor('AddonDoc', AddonDoc);
        metadataStore.registerEntityTypeCtor('AddonDocMap', AddonDocMap);
        metadataStore.registerEntityTypeCtor('AddonImage', AddonImage);
        metadataStore.registerEntityTypeCtor('AddonStation', AddonStation);
        metadataStore.registerEntityTypeCtor('AuthNetSubmission', AuthNetSubmission);
        metadataStore.registerEntityTypeCtor('BarcodePrintStatus', BarcodePrintStatus);
        metadataStore.registerEntityTypeCtor('BoxSize', BoxSize);
        metadataStore.registerEntityTypeCtor('CancellationReasonType', CancellationReasonType);
        metadataStore.registerEntityTypeCtor('CancellationRequest', CancellationRequest);
        metadataStore.registerEntityTypeCtor('CancellationRequestDetail', CancellationRequestDetail);
        metadataStore.registerEntityTypeCtor('CancellationRequestDetailStatus', CancellationRequestDetailStatus);
        metadataStore.registerEntityTypeCtor('CancellationRequestStatus', CancellationRequestStatus);
        metadataStore.registerEntityTypeCtor('CatalogFeed', CatalogFeed);
        metadataStore.registerEntityTypeCtor('Config', Config);
        metadataStore.registerEntityTypeCtor('CreditMemo', CreditMemo);
        metadataStore.registerEntityTypeCtor('CreditMemoLedgerEntry', CreditMemoLedgerEntry);
        metadataStore.registerEntityTypeCtor('CreditMemoLedgerEntryKind', CreditMemoLedgerEntryKind);
        metadataStore.registerEntityTypeCtor('CreditMemoStatus', CreditMemoStatus);
        metadataStore.registerEntityTypeCtor('CreditMemoType', CreditMemoType);
        metadataStore.registerEntityTypeCtor('DocSubmitType', DocSubmitType);
        metadataStore.registerEntityTypeCtor('EOQType', EOQType);
        metadataStore.registerEntityTypeCtor('Email', Email);
        metadataStore.registerEntityTypeCtor('EntityEvent', EntityEvent);
        metadataStore.registerEntityTypeCtor('EntityEventType', EntityEventType);
        metadataStore.registerEntityTypeCtor('EntityIssue', EntityIssue);
        metadataStore.registerEntityTypeCtor('Feature', Feature);
        metadataStore.registerEntityTypeCtor('FeatureChoice', FeatureChoice);
        metadataStore.registerEntityTypeCtor('FeatureKind', FeatureKind);
        metadataStore.registerEntityTypeCtor('GLAccount', GLAccount);
        metadataStore.registerEntityTypeCtor('GLSubmission', GLSubmission);
        metadataStore.registerEntityTypeCtor('GenId', GenId);
        metadataStore.registerEntityTypeCtor('Image', Image);
        metadataStore.registerEntityTypeCtor('InvoiceDetail', InvoiceDetail);
        metadataStore.registerEntityTypeCtor('InvoiceHeader', InvoiceHeader);
        metadataStore.registerEntityTypeCtor('InvoiceStatus', InvoiceStatus);
        metadataStore.registerEntityTypeCtor('ItemBin', ItemBin);
        metadataStore.registerEntityTypeCtor('ItemDetail', ItemDetail);
        metadataStore.registerEntityTypeCtor('ItemDetailAddon', ItemDetailAddon);
        metadataStore.registerEntityTypeCtor('ItemDetailHist', ItemDetailHist);
        metadataStore.registerEntityTypeCtor('ItemDetailLog', ItemDetailLog);
        metadataStore.registerEntityTypeCtor('ItemDetailStatus', ItemDetailStatus);
        metadataStore.registerEntityTypeCtor('ItemReplacement', ItemReplacement);
        metadataStore.registerEntityTypeCtor('ItemReplacementStatus', ItemReplacementStatus);
        metadataStore.registerEntityTypeCtor('ItemReplacementType', ItemReplacementType);
        metadataStore.registerEntityTypeCtor('JoDetail', JoDetail);
        metadataStore.registerEntityTypeCtor('JoDetailAddon', JoDetailAddon);
        metadataStore.registerEntityTypeCtor('JoExpectedShipDateHistory', JoExpectedShipDateHistory);
        metadataStore.registerEntityTypeCtor('JoHeader', JoHeader);
        metadataStore.registerEntityTypeCtor('JoHeaderPull', JoHeaderPull);
        metadataStore.registerEntityTypeCtor('JoNote', JoNote);
        metadataStore.registerEntityTypeCtor('JoNoteType', JoNoteType);
        metadataStore.registerEntityTypeCtor('JoPullBatch', JoPullBatch);
        metadataStore.registerEntityTypeCtor('JoStatus', JoStatus);
        metadataStore.registerEntityTypeCtor('Manifest', Manifest);
        metadataStore.registerEntityTypeCtor('ManifestGroup', ManifestGroup);
        metadataStore.registerEntityTypeCtor('ManifestGroupInvoice', ManifestGroupInvoice);
        metadataStore.registerEntityTypeCtor('Manufacturer', Manufacturer);
        metadataStore.registerEntityTypeCtor('ManufacturerCryptonym', ManufacturerCryptonym);
        metadataStore.registerEntityTypeCtor('ManufacturerFeatureKindMap', ManufacturerFeatureKindMap);
        metadataStore.registerEntityTypeCtor('ManufacturerFeedStatus', ManufacturerFeedStatus);
        metadataStore.registerEntityTypeCtor('ManufacturerImage', ManufacturerImage);
        metadataStore.registerEntityTypeCtor('ManufacturerProductTypeConfig', ManufacturerProductTypeConfig);
        metadataStore.registerEntityTypeCtor('ManufacturerProductTypeConfigAddon', ManufacturerProductTypeConfigAddon);
        metadataStore.registerEntityTypeCtor('NotificationEvent', NotificationEvent);
        metadataStore.registerEntityTypeCtor('NotificationQuery', NotificationQuery);
        metadataStore.registerEntityTypeCtor('NotificationSendLog', NotificationSendLog);
        metadataStore.registerEntityTypeCtor('NotificationTemplate', NotificationTemplate);
        metadataStore.registerEntityTypeCtor('NotificationType', NotificationType);
        metadataStore.registerEntityTypeCtor('PoCancelRequestQueue', PoCancelRequestQueue);
        metadataStore.registerEntityTypeCtor('PoDetail', PoDetail);
        metadataStore.registerEntityTypeCtor('PoDetailCancel', PoDetailCancel);
        metadataStore.registerEntityTypeCtor('PoDetailType', PoDetailType);
        metadataStore.registerEntityTypeCtor('PoHeader', PoHeader);
        metadataStore.registerEntityTypeCtor('PoNote', PoNote);
        metadataStore.registerEntityTypeCtor('PoNoteType', PoNoteType);
        metadataStore.registerEntityTypeCtor('PoStatus', PoStatus);
        metadataStore.registerEntityTypeCtor('PoTrx', PoTrx);
        metadataStore.registerEntityTypeCtor('PoTrxHist', PoTrxHist);
        metadataStore.registerEntityTypeCtor('Product', Product);
        metadataStore.registerEntityTypeCtor('ProductEOQ', ProductEOQ);
        metadataStore.registerEntityTypeCtor('ProductFeatureChoice', ProductFeatureChoice);
        metadataStore.registerEntityTypeCtor('ProductReplacement', ProductReplacement);
        metadataStore.registerEntityTypeCtor('ProductType', ProductType);
        metadataStore.registerEntityTypeCtor('ProductTypeAlt', ProductTypeAlt);
        metadataStore.registerEntityTypeCtor('ProductTypeFeatureMap', ProductTypeFeatureMap);
        metadataStore.registerEntityTypeCtor('ProductTypeImage', ProductTypeImage);
        metadataStore.registerEntityTypeCtor('ProductTypeTag', ProductTypeTag);
        metadataStore.registerEntityTypeCtor('ProductTypeTagMap', ProductTypeTagMap);
        metadataStore.registerEntityTypeCtor('ProxReceipt', ProxReceipt);
        metadataStore.registerEntityTypeCtor('ProxReceiptStatus', ProxReceiptStatus);
        metadataStore.registerEntityTypeCtor('ProxSubmission', ProxSubmission);
        metadataStore.registerEntityTypeCtor('ProxSubmissionStatus', ProxSubmissionStatus);
        metadataStore.registerEntityTypeCtor('QBAccount', QBAccount);
        metadataStore.registerEntityTypeCtor('QBItem', QBItem);
        metadataStore.registerEntityTypeCtor('ReturnReasonType', ReturnReasonType);
        metadataStore.registerEntityTypeCtor('ReturnRequest', ReturnRequest);
        metadataStore.registerEntityTypeCtor('ReturnRequestDetail', ReturnRequestDetail);
        metadataStore.registerEntityTypeCtor('ReturnRequestDetailStatus', ReturnRequestDetailStatus);
        metadataStore.registerEntityTypeCtor('ReturnRequestStatus', ReturnRequestStatus);
        metadataStore.registerEntityTypeCtor('ShipBin', ShipBin);
        metadataStore.registerEntityTypeCtor('ShipFrequency', ShipFrequency);
        metadataStore.registerEntityTypeCtor('Shipment', Shipment);
        metadataStore.registerEntityTypeCtor('ShipmentStatus', ShipmentStatus);
        metadataStore.registerEntityTypeCtor('ShippingBox', ShippingBox);
        metadataStore.registerEntityTypeCtor('StagedFeedRun', StagedFeedRun);
        metadataStore.registerEntityTypeCtor('StagedProductColor', StagedProductColor);
        metadataStore.registerEntityTypeCtor('StagedProductPart', StagedProductPart);
        metadataStore.registerEntityTypeCtor('StagedProductType', StagedProductType);
        metadataStore.registerEntityTypeCtor('SystemImage', SystemImage);
        metadataStore.registerEntityTypeCtor('TestParameter', TestParameter);
        metadataStore.registerEntityTypeCtor('UnwindEvent', UnwindEvent);
        metadataStore.registerEntityTypeCtor('UserPref', UserPref);
        metadataStore.registerEntityTypeCtor('Warehouse', Warehouse);
        metadataStore.registerEntityTypeCtor('WarningType', WarningType);
    }
}
